import { atom } from "recoil";
export const ExrciceAtom = atom({
  key: "ExrciceAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
